// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ComponentType, ReactElement, forwardRef, ForwardedRef,
} from 'react';

import { Input } from '../Input';

import { InputComponent } from './InputComponent';
import type { DebounceInputProps } from './types';

export const defaultDebounceTimeout = 300;

function DebounceInputInner<
  InputComponent extends
  | ComponentType<any>
  | keyof JSX.IntrinsicElements = 'input',
  WrappedComponentType = HTMLInputElement,
>(
  {
    component: WrappedComponent,
    debounceTimeout = defaultDebounceTimeout,
    ...rest
  }: DebounceInputProps<InputComponent, WrappedComponentType>,
  ref: ForwardedRef<RefElementType>,
): ReactElement {
  return (
    <Input
      {...rest}
      debounceTimeout={debounceTimeout}
      component={InputComponent}
      element={WrappedComponent}
      ref={ref}
    />
  );
}

export const DebounceInput = forwardRef(DebounceInputInner) as <
InputComponent extends
| ComponentType<any>
| keyof JSX.IntrinsicElements = 'input',
WrappedComponentType = HTMLInputElement,
>(props: DebounceInputProps<InputComponent, WrappedComponentType> & {
  ref?: Ref<RefElementType>;
})=>ReactElement;
